export default __webpack_public_path__ + "static/media/noPicture.741e49af.png";